import { render, staticRenderFns } from "./SenilePage.vue?vue&type=template&id=28fd83de&"
import script from "./SenilePage.vue?vue&type=script&lang=js&"
export * from "./SenilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports